import { configureStore } from '@reduxjs/toolkit';
import credentialsReducer from './credentialsSlice';
import userDataReducer from './userSlice';

const store = configureStore({
    reducer: {
        credentials: credentialsReducer,
        userData: userDataReducer
    }
});

export default store;